 import React from 'react';
 import Header from './header'; 
 
 const Topbar = () => {

    const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");

  window.location.href = "/login";
};


   return (
 <div>
    <Header />
        <nav className="navbar">
            <div className="navbar-header">
                <a href="index.html" className="navbar-brand">
                    <img className="logo-expand" alt="" src="/img/plogo.svg" style={{ height: "70px" }}/>
                    <img className="logo-collapse" alt="" src="/img/plogo.svg" style={{ height: "70px" }}/>
                   
                </a>
            </div>           
            
           
            <div className="spacer"></div>
            
            <div className="btn-list dropdown d-none d-md-flex"><a href="javascript:void(0);" className="btn btn-primary dropdown-toggle ripple" data-toggle="dropdown">  Admin</a>
                <div className="dropdown-menu dropdown-left animated flipInY"> <a className="dropdown-item" href="/ChangePassword">My Profile</a>  
                    
                    <div className="dropdown-divider"></div><button className="dropdown-item" onClick={handleLogout}> Logout </button>
                </div>
            </div>
             
            
            
             
        </nav>
        </div>
 
           
  )
}

export default Topbar;